module.exports = function() {
  return new Worker(__webpack_public_path__ + "d21cf2c10c32bcc34455.worker.js");
};